// src/pages/home/HomeContent.js

import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import SectionBlock from "../../components/Blocks/SectionBlock";
import CarerSelectionModal from "../../components/Modals/CarerSelectionModal";

const HomeContent = ({ page, errorMessage, loading }) => {
  const { t } = useTranslation();

  // Carer Pop Up State
  const [isOpen, setIsOpen] = useState(false);

  const handleCarerTypeBtnClick = () => {
    setIsOpen(true);
  };

  if (loading) {
    return (
      <div className="flex text-center justify-center items-center h-full -mt-10 text-gray-500">
        {t("common:loading")}
      </div>
    );
  }

  if (!loading && errorMessage) {
    return (
      <div className="flex text-center justify-center items-center h-full -mt-10 text-gray-500">
        {errorMessage.message}
      </div>
    );
  }

  return (
    <Fragment>
      <CarerSelectionModal isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className="homepage">
        {page &&
          page.content.map((section, index) => (
            <SectionBlock
              key={index}
              section={section}
              carerModal={setIsOpen}
            />
          ))}
      </div>
    </Fragment>
  );
};

export default HomeContent;
